import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import {environment} from '../../environments/environment';
import { K5RevertMessageModel } from "../models/k5RevertMessage.model";

@Injectable({
    providedIn: 'root'
  })
export class RevertD2LAdjustmentService {
    private revertresponse;
    private D2L_REVERT_SVC_URL = environment.D2L_REVERT_SVC_URL;

    private revertItemsSubject: Subject<any[]>;
    revertItemsObservable: Observable<any[]>;

    constructor(private httpClient: HttpClient) {
        this.revertItemsSubject = new Subject<any[]>();
        this.revertItemsObservable = this.revertItemsSubject.asObservable();
    }

    postRevertD2LAdjustmentData(auditId: number, identityId: string, schoolId: string, classroomId: string, itemIds: number[]) {
        this.sendD2LPostRequest(auditId, identityId, schoolId, classroomId, itemIds).subscribe((
          (data: any) => {
            this.revertresponse = data;
            this.revertItemsSubject.next(this.revertresponse);
            return data;
          }
      ));
      return this.revertresponse;
      }
  
      sendD2LPostRequest(auditId: number, identityId: string, schoolId: string, classroomId: string, itemIds: number[]) {
        return this.httpClient.post<any>(this.D2L_REVERT_SVC_URL, { auditId: auditId, identityId: identityId, schoolId: schoolId, classroomId: classroomId,
          itemIds: itemIds });
      }
  
}